<div class="fiados-page">
  <div class="fiados-header">
    <div>
      <h2 class="fiados-title">Fiados</h2>
      <p class="fiados-subtitle">Caderno de débitos por cliente</p>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="erro">
    {{erro}}
  </div>

  <section class="fiados-box filtro-box">
    <div class="box-header filtro-header">
      <div class="box-title">
        <i class="fa fa-filter"></i>
        <span>Filtros</span>
      </div>

      <button class="btn-limpar" type="button" (click)="limpeFiltros()">
        <i class="fa fa-undo"></i>
        <span>Limpar filtros</span>
      </button>
    </div>

    <div class="filtro-grid">
      <div class="campo campo-busca">
        <label>Busca</label>
        <div class="campo-icone">
          <i class="fa fa-search"></i>
          <input class="form-control" [(ngModel)]="filtro.q" placeholder="Cliente, telefone ou pedido" />
        </div>

        <div class="filtro-contato-badge" *ngIf="temFiltroContato()">
          <span>
            <i class="fa fa-user"></i>
            Filtrando por {{obtenhaLabelContatoFiltro()}}
          </span>
          <button type="button" (click)="limpeFiltroContato()">
            <i class="fa fa-times"></i>
            Limpar cliente
          </button>
        </div>
      </div>

      <div class="campo">
        <label>Início</label>
        <kendo-datepicker [(ngModel)]="filtro.di" format="dd/MM/yyyy"></kendo-datepicker>
      </div>

      <div class="campo">
        <label>Fim</label>
        <kendo-datepicker [(ngModel)]="filtro.df" format="dd/MM/yyyy"></kendo-datepicker>
      </div>

      <div class="campo">
        <label>Exibir</label>
        <select class="form-control" [(ngModel)]="filtro.todos">
          <option [ngValue]="false">Somente em aberto</option>
          <option [ngValue]="true">Todos</option>
        </select>
      </div>

      <div class="campo campo-pagina">
        <label>Por pág.</label>
        <select class="form-control" [(ngModel)]="filtro.t" (ngModelChange)="altereTamanhoPagina()">
          <option *ngFor="let tamanho of tamanhosPagina" [ngValue]="tamanho">{{tamanho}}</option>
        </select>
      </div>

      <div class="campo campo-acao">
        <button class="btn-filtrar" type="button" (click)="filtrar()">
          <i class="fa fa-search"></i>
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </section>

  <section class="fiados-box">
    <div class="abas-header">
      <button class="aba-btn" type="button" [class.ativa]="abaAtiva === 'abertos'" (click)="selecioneAba('abertos')">
        Em aberto
      </button>
      <button class="aba-btn" type="button" [class.ativa]="abaAtiva === 'acertos'" (click)="selecioneAba('acertos')">
        Histórico de acertos
      </button>
    </div>

    <ng-container *ngIf="abaAtiva === 'abertos'">
      <div class="box-body" *ngIf="carregando">
        <div class="estado-vazio">Carregando fiados...</div>
      </div>

      <div class="box-body" *ngIf="!carregando && !temLancamentos()">
        <div class="estado-vazio">Nenhum lançamento de fiado encontrado.</div>
      </div>

      <div class="lista-grupos" *ngIf="!carregando && temLancamentos()">
        <div class="grupo-card" *ngFor="let grupo of agrupadoPorContato; trackBy: trackByGrupo">
          <div class="grupo-topo">
            <div class="grupo-identificacao">
              <div class="grupo-avatar">{{obtenhaIniciais(grupo?.contato?.nome)}}</div>

              <div class="grupo-cliente">
                <h4>
                  <a class="cliente-link"
                     [routerLink]="obtenhaLinkContato(grupo.contato)"
                     [state]="{contato: grupo.contato}">
                    {{grupo.contato?.nome || 'Cliente não identificado'}}
                  </a>
                </h4>
                <div class="grupo-meta">
                  <span *ngIf="grupo.contato?.telefone">
                    <i class="fa fa-phone"></i>
                    {{grupo.contato?.telefone}}
                  </span>
                  <span class="conta-saldo" [ngClass]="obtenhaClasseSaldoConta(grupo)">
                    Conta: <strong>{{obtenhaSaldoConta(grupo) | currency:'BRL'}}</strong>
                  </span>
                </div>
              </div>
            </div>

            <div class="grupo-resumo">
              <div><strong>Saldo:</strong> <span class="saldo-fiado-aberto">{{grupo.totalSaldo | currency:'BRL'}}</span></div>
              <div><strong>Original:</strong> <span>{{grupo.totalOriginal | currency:'BRL'}}</span></div>
              <div class="grupo-acoes">
                <button class="btn-acerto btn-credito" type="button" (click)="abraModalCredito(grupo)">
                  <i class="fa fa-plus-circle"></i>
                  Adicionar crédito
                </button>
                <button class="btn-acerto" type="button" *ngIf="possuiLancamentoEmAberto(grupo)" (click)="abraModalAcerto(grupo)">
                  <i class="fa fa-handshake-o"></i>
                  Fazer acerto
                </button>
              </div>
            </div>
          </div>

          <div class="grupo-tabela desktop-table">
            <div class="tabela-titulo">
              <i class="fa fa-file-text-o"></i>
              <span>Últimos pedidos</span>
            </div>
            <table class="table table-sm mb-0">
              <thead>
              <tr>
                <th>Pedido</th>
                <th>Data</th>
                <th>Status</th>
                <th>Valor original</th>
                <th>Saldo</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let lancamento of obtenhaUltimosLancamentos(grupo); trackBy: trackByLancamento">
                <td>
                  <a [routerLink]="'/admin/pedidos/detalhes/' + lancamento?.pedido?.guid">
                    #{{lancamento?.pedido?.codigo}}
                  </a>
                </td>
                <td>{{formatarData(lancamento?.dataLancamento)}}</td>
                <td>
                  <span class="status-chip">{{obtenhaLabelStatus(lancamento?.status)}}</span>
                </td>
                <td>{{lancamento?.valorOriginal | currency:'BRL'}}</td>
                <td><span class="saldo-fiado-aberto">{{lancamento?.saldo | currency:'BRL'}}</span></td>
                <td class="col-detalhe">
                  <a [routerLink]="'/admin/pedidos/detalhes/' + lancamento?.pedido?.guid">
                    <i class="fa fa-angle-right"></i>
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <button class="btn-ver-todos" type="button" *ngIf="grupo.lancamentos?.length > 3" (click)="abraModalTodosPedidos(grupo)">
              Ver todos os pedidos ({{grupo.lancamentos.length}})
              <i class="fa fa-angle-right"></i>
            </button>
          </div>

          <div class="grupo-lista-mobile">
            <div class="lancamento-card" *ngFor="let lancamento of grupo.lancamentos; trackBy: trackByLancamento">
              <div class="lancamento-linha lancamento-topo">
                <a class="pedido-link" [routerLink]="'/admin/pedidos/detalhes/' + lancamento?.pedido?.guid">
                  #{{lancamento?.pedido?.codigo}}
                </a>
                <a class="detalhe-link" [routerLink]="'/admin/pedidos/detalhes/' + lancamento?.pedido?.guid">
                  <i class="fa fa-angle-right"></i>
                </a>
              </div>

              <div class="lancamento-linha">
                <div class="lancamento-info">
                  <i class="fa fa-calendar-o"></i>
                  <span>{{formatarData(lancamento?.dataLancamento)}}</span>
                </div>
              </div>

              <div class="lancamento-linha">
                <span class="status-chip">{{obtenhaLabelStatus(lancamento?.status)}}</span>
              </div>

              <div class="lancamento-valores">
                <div>
                  <span class="valor-label">Valor original</span>
                  <strong>{{lancamento?.valorOriginal | currency:'BRL'}}</strong>
                </div>
                <div>
                  <span class="valor-label">Saldo</span>
                  <strong class="saldo-fiado-aberto">{{lancamento?.saldo | currency:'BRL'}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="paginacao-box">
          <span>Mostrando {{inicioExibicao('lancamentos')}} a {{fimExibicao('lancamentos')}} de {{resposta?.total || 0}} registros</span>
          <div class="paginacao-acoes">
            <button type="button" class="btn-paginacao" [disabled]="inicioLancamentos <= 0" (click)="alterePagina(-1, 'lancamentos')">
              Anterior
            </button>
            <span class="pagina-atual">Página {{paginaAtual('lancamentos')}} de {{totalPaginasLancamentos}}</span>
            <button type="button" class="btn-paginacao" [disabled]="paginaAtual('lancamentos') >= totalPaginasLancamentos" (click)="alterePagina(1, 'lancamentos')">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="abaAtiva === 'acertos'">
      <div class="box-body" *ngIf="carregandoAcertos">
        <div class="estado-vazio">Carregando acertos...</div>
      </div>

      <div class="box-body" *ngIf="!carregandoAcertos && !temAcertos()">
        <div class="estado-vazio">Nenhum acerto encontrado.</div>
      </div>

      <div class="box-body" *ngIf="!carregandoAcertos && temAcertos()">
        <div class="acertos-lista">
          <div class="acerto-card" *ngFor="let acerto of obtenhaAcertos(); trackBy: trackByAcerto">
            <div class="acerto-resumo">
              <div>
                <div class="acerto-label">Data</div>
                <strong>{{formatarData(acerto?.dataPagamento)}}</strong>
              </div>
              <div>
                <div class="acerto-label">Cliente</div>
                <strong>
                  <a class="cliente-link"
                     [routerLink]="obtenhaLinkContato(acerto?.contato)"
                     [state]="{contato: acerto?.contato}">
                    {{acerto?.contato?.nome || '-'}}
                  </a>
                </strong>
              </div>
              <div>
                <div class="acerto-label">Pagamento</div>
                <strong>{{acerto?.formaDePagamento?.descricao || '-'}}</strong>
              </div>
              <div>
                <div class="acerto-label">Valor total</div>
                <strong>{{acerto?.valorTotal | currency:'BRL'}}</strong>
              </div>
              <div class="acerto-acao">
                <button class="btn-detalhes" type="button" (click)="toggleDetalhesAcerto(acerto)">
                  {{detalhesAcertos[acerto.id] ? 'Ocultar itens' : 'Ver itens'}}
                </button>
              </div>
            </div>

            <div class="acerto-observacao" *ngIf="acerto?.observacao">
              {{acerto.observacao}}
            </div>

            <div class="acerto-detalhes" *ngIf="detalheAcertoVisivel(acerto)">
              <div *ngIf="detalhesAcertosCarregando[acerto.id]">Carregando itens...</div>
              <div *ngIf="detalhesAcertos[acerto.id]">
                <div class="acerto-item" *ngFor="let item of detalhesAcertos[acerto.id]?.itens">
                  <div>
                    Pedido
                    <a [routerLink]="'/admin/pedidos/detalhes/' + item?.pedido?.guid">
                      #{{item?.pedido?.codigo}}
                    </a>
                  </div>
                  <strong>{{item?.valorPago | currency:'BRL'}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="paginacao-box">
          <span>Mostrando {{inicioExibicao('acertos')}} a {{fimExibicao('acertos')}} de {{obtenhaTotalAcertos()}} registros</span>
          <div class="paginacao-acoes">
            <button type="button" class="btn-paginacao" [disabled]="inicioAcertos <= 0" (click)="alterePagina(-1, 'acertos')">
              Anterior
            </button>
            <span class="pagina-atual">Página {{paginaAtual('acertos')}} de {{totalPaginasAcertos}}</span>
            <button type="button" class="btn-paginacao" [disabled]="paginaAtual('acertos') >= totalPaginasAcertos" (click)="alterePagina(1, 'acertos')">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </section>

  <div class="modal-backdrop-fiado" *ngIf="grupoTodosPedidos">
    <div class="modal-todos-pedidos">
      <button class="modal-fechar" type="button" (click)="fecheModalTodosPedidos()">
        <i class="fa fa-times"></i>
      </button>

      <div class="modal-titulo">Todos os pedidos</div>

      <div class="modal-cliente-linha">
        <div class="grupo-avatar modal-avatar">{{obtenhaIniciais(grupoTodosPedidos?.contato?.nome)}}</div>
        <strong>{{grupoTodosPedidos?.contato?.nome || 'Cliente não identificado'}}</strong>

        <div class="campo-icone modal-busca">
          <i class="fa fa-search"></i>
          <input class="form-control" [(ngModel)]="buscaTodosPedidos" placeholder="Buscar pedido" />
        </div>
      </div>

      <div class="modal-tabela">
        <table class="table table-sm mb-0">
          <thead>
          <tr>
            <th>Pedido</th>
            <th>Data</th>
            <th>Status</th>
            <th>Valor original</th>
            <th>Saldo</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let lancamento of obtenhaLancamentosTodosPedidos(); trackBy: trackByLancamento">
            <td>
              <a [routerLink]="'/admin/pedidos/detalhes/' + lancamento?.pedido?.guid">
                #{{lancamento?.pedido?.codigo}}
              </a>
            </td>
            <td>{{formatarData(lancamento?.dataLancamento)}}</td>
            <td><span class="status-chip">{{obtenhaLabelStatus(lancamento?.status)}}</span></td>
            <td>{{lancamento?.valorOriginal | currency:'BRL'}}</td>
            <td><span class="saldo-fiado-aberto">{{lancamento?.saldo | currency:'BRL'}}</span></td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="modal-acoes">
        <button class="btn-modal-cancelar" type="button" (click)="fecheModalTodosPedidos()">Fechar</button>
        <button class="btn-modal-confirmar" type="button" *ngIf="possuiLancamentoEmAberto(grupoTodosPedidos)" (click)="abraModalAcerto(grupoTodosPedidos)">
          Fazer acerto
        </button>
      </div>
    </div>
  </div>
</div>
